import React, { useEffect, useState } from "react";
import {
  IInsightsCategory,
  fetchInsightsCategoryApiCall,
} from "./InsightsController";
import InsightGrid from "./InsightGrid";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { searchIcon } from "../../assets/icons/SvgIconList";
import PublicHeader from "../public-header/PublicHeader";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import CopyrightFooter from "../../components/common/CopyrightFooter";
import Loader from "../../components/common/Loader";
import { PUBLIC_HEADER_TABS, PUBLIC_TABS } from "../../utils/AppEnumerations";

const InsightsView = () => {
  const { t } = UseTranslationHook();
  let timer: NodeJS.Timeout;
  const [insightsCategoryList, setInsightsCategoryList] = useState<
    IInsightsCategory[]
  >([]);
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [publicLoader, setPublicLoader] = useState(true);
  const [cid, setCid] = useState<number | null>(null);
  const [enterpriseSearch, setEnterpriseSearch] = useState("");
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Thousand),
      current_page: 1,
      sort_by: "",
      order_by: "DESC",
    },
  });
  useEffect(() => {
    document.title = PUBLIC_TABS.Insights;
    fetchInsightsCategoryApiCall(
      setLoading,
      setInsightsCategoryList,
      setPagination,
      pagination,
      setCategoryId
    );
    setTimeout(async () => {
      setPublicLoader(false);
    }, 2000);
  }, []);
  const handleCategoryClick = (id: number | null) => {
    setCategoryId(id);
  };

  return (
    <div className="bg-skin-home-bg h-screen overflow-y-scroll">
      {loading || publicLoader ? (
        <div className="h-screen flex items-center flex-col bg-skin-home-bg">
          <Loader />
        </div>
      ) : (
        <>
          <div className="h-24 relative">
            <PublicHeader activeTab={PUBLIC_HEADER_TABS.Insights} />
          </div>

          <div className="flex flex-col justify-center items-center">
            <div className="xl:w-3/4 w-full p-3 ">
              <div className="w-full p-2">
                <div
                  className={`mr-5 mb-1 flex w-full items-center p-3 web-shadow`}
                >
                  <div className="w-6 h-6">{searchIcon}</div>
                  <div className="w-full ml-5 flex items-center" id="bell-ic">
                    <input
                      className="w-full focus:outline-none"
                      type="search"
                      placeholder="Search here"
                      id="bell-ic"
                      onChange={(event) =>
                        setEnterpriseSearch &&
                        setEnterpriseSearch(event.target.value)
                      }
                      value={enterpriseSearch}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-7">
                <div className="filters flex overflow-x-scroll space-x-4">
                  <button
                    className={`flex-shrink-0 ${categoryId === null
                      ? `bg-skin-home-slide`
                      : `bg-skin-insights-card text-skin-insights overflow-hidden`
                      }`}
                    data-filter="*"
                    onClick={() => {
                      handleCategoryClick(null);
                    }}
                  >
                    {t("all")}
                  </button>
                  {insightsCategoryList &&
                    insightsCategoryList.map((item, index) => (
                      <button
                        onClick={() => {
                          handleCategoryClick(item.id);
                        }}
                        className={`flex-shrink-0  overflow-hidden ${categoryId === item.id
                          ? `bg-skin-home-slide`
                          : `text-skin-insights bg-skin-insights-card`
                          }`}
                        key={index}
                        data-filter=".cat-1"
                      >
                        {item.category_title}
                      </button>
                    ))}
                </div>
              </div>
            </div>
            <div className="mt-4 xl:w-3/4 w-full p-4 xl:p-0">
              <InsightGrid
                categoryId={categoryId}
                enterpriseSearch={enterpriseSearch}
              />
            </div>
          </div>

          <CopyrightFooter />
        </>
      )}
    </div>
  );
};

export default InsightsView;
